import Utils from '../utils';

const { Communication } = Utils;

export default class ShipStationCommunication extends Communication {
	static ssApiUrlPrefix = `${this.accountApiUrlPrefix}/ssapi`;

	/**
	 * Make a HTTP request to load lookup data object from ShipStation.
	 */
	static loadLookup() {
		const queryString =
			'keys=AllMarketplaces,AllCarriers,Marketplaces,OrderExtractList,Presets,Stores,Settings';

		return this.axiosRequest({
			url: `${this.ssApiUrlPrefix}/data/lookup?${queryString}`,
		});
	}

	/**
	 * Make a HTTP request to save Settings in ShipStation.
	 *	@param {string} settings The string format is "key1=<val1>&key2=<val2>&...".
	 */
	static saveSettings(settings) {
		return this.axiosRequest({
			url: `${this.ssApiUrlPrefix}/Account/SaveSettings`,
			method: 'post',
			data: settings,
		});
	}

	/**
	 * Make a HTTP request to Get store status.
	 * @return {object}
	 */
	static async getStatus() {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/ssapi/status`,
		});
	}

	static upgradeWebbatchAccount(data) {
		return this.axiosRequest({
			url: `${this.ssApiUrlPrefix}/Account/upgradewebbatchaccount`,
			method: 'post',
			data,
		});
	}
}
